// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2mcuGjDICiNt","wrapper_gray":"_27GLVlmhBRUH","wrapper_loading":"_2tAWCcgsNG4x","loader":"sl7SPk4hAs9d","rotation":"_2kww0KaabVuy"};